import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

export default function Completed({ theme, ...props }) {
  return (
    <svg
      aria-labelledby={props.ariaTags.labelledBy}
      aria-hidden={props.ariaTags.hidden}
      className={cx(theme.container, theme[props.svg], props.className)}
      shapeRendering="geometricPrecision"
      tabIndex={props.tabIndex}
      vectorEffect="non-scaling-stroke"
      viewBox="-3 -2.5 40 40"
      xmlns="http://www.w3.org/2000/svg"
    >
      {props.title ? (
        <title id={props.ariaTags.labelledBy} lang="en">
          {props.title}
        </title>
      ) : null}
      <g
        className={theme.stroke}
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M.593604 17.486998c.07854-8.93046 7.3821-16.10598 16.3119-16.02744 8.9298.0792 16.10532 7.38144 16.02678 16.3119-.07854 8.9298-7.38144 16.10532-16.31124 16.02678-8.93046-.07854-16.10598-7.38144-16.02744-16.31124zM7.94838 18.329422l5.41134 5.41134M13.354704 23.740564l12.2232-12.2232" />
      </g>
    </svg>
  )
}

Completed.propTypes = {
  ariaTags: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  svg: PropTypes.string.isRequired,
  theme: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  className: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
}
